module.exports = __webpack_public_path__ + "img/guardEmploy.d4e2560f.svg";